import { useState } from 'react';
import useToken from 'hooks/useToken';

/**
 * Custom hook para manejar operaciones de la orden
 */
const useOrdenOperations = () => {
    const { token, setToken } = useToken();
    const [loadingEdit, setLoadingEdit] = useState(false);

    /**
     * Cambia la fecha de la orden
     */
    const cambiarFecha = async (orden, nuevaFecha, onSuccess, onError) => {
        const jDataSend = {
            idOrden: orden.idOrden,
            dFechaVenta: nuevaFecha
        };

        try {
            const response = await fetch("/api/orden/changeOrderDate/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                const objResponse = await response.json();

                if (objResponse.iResponseType === 1) {
                    const data = JSON.parse(objResponse.detalles);
                    onSuccess?.(data[0]);
                } else {
                    onError?.(objResponse.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.('Hubo un problema con la petición Fetch');
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error);
            onError?.('Hubo un problema con la petición Fetch: ' + error);
        }
    };

    /**
     * Cambia la forma de pago de la orden
     */
    const cambiarFormaPago = async (orden, nuevaFormaPago, onSuccess, onError) => {
        const jDataSend = {
            idOrden: orden.idOrden,
            vClave: nuevaFormaPago
        };

        try {
            const response = await fetch("/api/orden/changePaymentMethod/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                const objResponse = await response.json();

                if (objResponse.iResponseType === 1) {
                    const data = JSON.parse(objResponse.detalles);
                    onSuccess?.(data[0]);
                } else {
                    onError?.(objResponse.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.('Hubo un problema con la petición Fetch');
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error);
            onError?.('Hubo un problema con la petición Fetch: ' + error);
        }
    };

    /**
     * Cambia estatus de distribución de la orden
     */
    const cambiarDistribucion = async (orden, bIsDistribucion, onSuccess, onError) => {
        const jDataSend = {
            idOrden: orden.idOrden,
            bIsDistribucion: bIsDistribucion
        };

        try {
            const response = await fetch("/api/orden/changeDistribution/", {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(jDataSend)
            });

            if (response.ok) {
                const objResponse = await response.json();

                if (objResponse.iResponseType === 1) {
                    onSuccess?.();
                } else {
                    onError?.(objResponse.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.('Hubo un problema con la petición Fetch');
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error);
            onError?.('Hubo un problema con la petición Fetch: ' + error);
        }
    };

    /**
     * Verifica si orden tiene pagos
     */
    const verificarPagosOrden = async (idOrden, onSuccess, onError) => {
        try {
            const response = await fetch("/api/orden/revisarPagosOrdenes/?idOrden=" + idOrden, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const responseType = await response.json();

                if (responseType.iResponseType === 1) {
                    onSuccess?.();
                } else {
                    onError?.(responseType.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
            onError?.(error.message);
        }
    };

    /**
     * Verifica si orden tiene licencias activas
     */
    const verificarLicenciasActivas = async (idOrden, onSuccess, onError) => {
        try {
            const response = await fetch("/api/orden/revisaLicenciasActivas/?idOrden=" + idOrden, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const responseType = await response.json();

                if (responseType.iResponseType === 1) {
                    onSuccess?.();
                } else {
                    onError?.(responseType.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
            onError?.(error.message);
        }
    };

    /**
     * Cancela la orden
     */
    const cancelarOrden = async (idOrden, onSuccess, onError) => {
        setLoadingEdit(true);

        try {
            const response = await fetch("/api/orden/cancelarOrden/?idOrden=" + idOrden, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + token,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                const responseType = await response.json();

                if (responseType.iResponseType === 1) {
                    onSuccess?.(responseType.vMessage);
                } else {
                    onError?.(responseType.vMessage);
                }
            } else {
                if (response.status === 401) {
                    setToken(null);
                    location.href = "";
                }
                onError?.(response.status + ' ' + response.statusText);
            }
        } catch (error) {
            console.log('Hubo un problema con la peticion Fetch:' + error.message);
            onError?.(error.message);
        } finally {
            setLoadingEdit(false);
        }
    };

    return {
        loadingEdit,
        setLoadingEdit,
        cambiarFecha,
        cambiarFormaPago,
        cambiarDistribucion,
        verificarPagosOrden,
        verificarLicenciasActivas,
        cancelarOrden
    };
};

export default useOrdenOperations;
